import type { DateValue } from '../../../types/form/form-fields/field-values';
import type { ConstraintFunction } from '../../../types/form/form-section/config';

// Enum for date picker units (excludes hours since dates are day-level precision)
export enum DateUnit {
	DAYS = 'days',
	WEEKS = 'weeks',
	MONTHS = 'months',
}

export const dateValueEqualToCheck: ConstraintFunction<DateValue> = (
	value: DateValue | undefined,
	constraint: string[],
) => value !== undefined && value.date === constraint[0];

export const dateValueDoesNotEqualToCheck: ConstraintFunction<DateValue> = (
	value: DateValue | undefined,
	constraint: string[],
) => value === undefined || value.date !== constraint[0];

export const dateValueGreaterThanCheck: ConstraintFunction<DateValue> = (
	value: DateValue | undefined,
	constraint: string[],
) => value !== undefined && value.date > constraint[0];

export const dateValueGreaterThanOrEqualToCheck: ConstraintFunction<DateValue> = (
	value: DateValue | undefined,
	constraint: string[],
) => value !== undefined && value.date >= constraint[0];

export const dateValueLessThanCheck: ConstraintFunction<DateValue> = (
	value: DateValue | undefined,
	constraint: string[],
) => value !== undefined && value.date < constraint[0];

export const dateValueLessThanOrEqualToCheck: ConstraintFunction<DateValue> = (
	value: DateValue | undefined,
	constraint: string[],
) => value !== undefined && value.date <= constraint[0];

// BETWEEN: Inclusive of minimum and maximum
export const dateValueBetweenCheck: ConstraintFunction<DateValue> = (
	value: DateValue | undefined,
	constraint: string[],
) => {
	if (value === undefined) {
		return false;
	}
	const min = constraint[0];
	const max = constraint[1];
	return value.date >= min && value.date <= max;
};

export const dateValueEmptyCheck: ConstraintFunction<DateValue> = (value: DateValue | undefined) =>
	value === undefined || !value.date;

export const dateValueNotEmptyCheck: ConstraintFunction<DateValue> = (
	value: DateValue | undefined,
) => value !== undefined && !!value.date;
